BatchGeoStore.addReducer(
  "Cluster",
  { enabled: null },
  {
    CLUSTER_ENABLE: function (state) {
      return Object.assign(state, { enabled: true });
    },
    CLUSTER_DISABLE: function (state) {
      return Object.assign(state, { enabled: false });
    },
    CLUSTER_SET_ENABLED: function (state, action) {
      return Object.assign(state, { enabled: !!action.enabled });
    },
    CLUSTER_TOGGLE: function (state) {
      return Object.assign(state, { enabled: !state.enabled });
    },
  },
);
